import { action } from "../const";

let initialState = {
    active: "Overview",
    userList: undefined,
    selected_user: undefined,
    // selected_user: {
    //     avatar: "woogi/0.1/upload/uploadProfile/1/0/0/7/1007237.png",
    //     user_id: "999847",
    //     nickname: "master"
    // },
    activitiesLog: {
        videos: undefined,
        questions: null
    },
    activitiesLogIndex: 1,
    timeProgress: undefined,
    totalProgressTime: undefined
}

export default function statisticsReducer(state = initialState, data) {

    switch (data.type) {

        case action.STATISTICS_SET_USER_INFO:
            return {
                ...state,
                selected_user: data.user
            }

        case action.STATISTICS_TAB_CHANGE:
            return {
                ...state,
                active: data.tab
            }

        case action.STATISTICS_USERS_LIST:
            return {
                ...state,
                userList: data.users || []
            }

        case action.ACTIVITIES_LOGS_VIDEOS:
            return {
                ...state,
                activitiesLog: { ...state.activitiesLog, videos: data.videos }
            }

        case action.ACTIVITIES_LOGS_INDEX:
            return {
                ...state,
                activitiesLogIndex: data.payload
            }

        case action.ACTIVITIES_LOGS_QUESTIONS:
            let questions = state.activitiesLog.questions || [];
            questions = Array.from(new Set(questions.concat(data.payload)));
            return {
                ...state,
                activitiesLog: { ...state.activitiesLog, questions }
            }

        case action.ACTIVITIES_LOGS_QUESTIONS_EMPTY:
            return {
                ...state,
                activitiesLog: { ...state.activitiesLog, questions: null }
            }

        case action.ACTIVITIES_TIME_PROGRESS:
            return {
                ...state,
                timeProgress: data.progress,
                totalProgressTime: data.totalProgressTime,
            }

        case action.INITIALIZE_SETTINGS:
            return { ...initialState, active: 'Overview' }

        default:
            break;
    }
    return state;
}